export default {
  SERVICES: (state) => {
    return state.services
  }
}
